import { useEffect, useState } from "react";
import SuperAdminTenantCard from "./components/tenants/SuperAdminTenantCard";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { axios_superadmin } from "../../../axios";
import { toast } from "react-toastify";
import Div from "@jumbo/shared/Div";
import AddIcon from "@mui/icons-material/Add";
import AddTenantModal from "./components/tenants/AddTenantModal";

const SuperAdminTenantList = () => {
    const [tenantData, setTenantData] = useState([]);
    const [openAdd, setOpenAdd] = useState(false);
    const [imageString, setImageString] = useState("");
    const [loading,setLoading] = useState(false);

    const initialState = {
        instanceType: "dev",
        tenantCode: "",
        tenantName: "",
        database: "",
        sftpConfig: { host: "", port: 22, username: "", password: "" },
        isActive: true,
        tenant_image_url: "",
        email: "",
        sessionExpire:""
    };

    const [tenantValues, setTenantValues] = useState(initialState);

    let { instanceType, tenantCode, tenantName, database, sftpConfig, isActive, tenant_image_url, email, sessionExpire } = tenantValues;

    useEffect(() => {
        getTenantData();
    }, []);

    const handleAddClick = async () => {
        setOpenAdd(!openAdd);
    };

    const getTenantData = async () => {
        try{
            const resposne = await axios_superadmin.get("/superAdmin/apps/mappings");
            setTenantData(resposne.data);
        } catch (error) {
        }
    };

    const handleAddChange = e => {
        const { id, value } = e.target;

        if (id.includes('.')) {
            const [parent, child] = id.split('.');
            setTenantValues(prevState => ({
                ...prevState,
                [parent]: {
                    ...prevState[parent],
                    [child]: value
                }
            }));
        } else {
            setTenantValues({ ...tenantValues, [id]: value });
        }
    };

    const handleAddSubmit = async() => {
        database = tenantCode;
        setLoading(true);
        try{
            const response = await axios_superadmin.post("/superAdmin/tenants/add", { tenantName, tenantCode, database, instanceType, sftpConfig, isActive, tenant_image_url: imageString, email, sessionExpire})
            await getTenantData();
            toast.success(response.data.message);
        } catch (error) {
        } finally {
            setOpenAdd(false);
            setLoading(false);
        }
    };

    const convertToBase64 = async file => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setImageString(reader.result);
        };
    };

    const handleFileChange = async e => {
        let file = e.target.files[0];

        try {
            await convertToBase64(file);
        } catch (error) {
        }
    };

    const handleEditSubmit = async (id, data) => {
        setLoading(true);
        try {
            const response = await axios_superadmin.post(`/superAdmin/tenants/${id}`, data)
            await getTenantData();
            toast.success(response.data.message);
        } catch (error) {
        } finally {
            setLoading(false)
        }
       

    };
    

    return (
        <Div sx={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box width="70%">
                <Box sx={{ display: "flex", justifyContent: "space-between", margin: "2%" }}>
                    <Typography variant={"h2"}>Tenants </Typography>
                    <AddIcon sx={{ fontSize: "2rem", cursor: "pointer" }} onClick={handleAddClick} />
                </Box>

                {tenantData?.length > 0 ? tenantData.map((tenant, i) => <SuperAdminTenantCard key={tenant.subscriptionId} tenant={tenant} handleEditSubmit={handleEditSubmit} editLoading={loading}/> ) 
                : <Typography variant="h5" color="black">{" "}Loading...</Typography>}
            </Box>

            <Box display="flex" justifyContent="center">
                <AddTenantModal 
                    openAdd = {openAdd}
                    setOpenAdd = {setOpenAdd}
                    tenantName = {tenantName}
                    tenantCode = {tenantCode}
                    email = {email}
                    sftpHost = {sftpConfig.host}
                    sftpUsername = {sftpConfig.username}
                    sftpPassword = {sftpConfig.password}
                    sessionExpire = {sessionExpire}
                    handleFileChange = {handleFileChange}
                    handleAddSubmit = {handleAddSubmit}
                    handleAddChange={handleAddChange}
                    loading = {loading}
                />

                {/* <Modal open={openAdd} onClose={() => setOpenAdd(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Div sx={style}>
                        <Typography id="modal-modal-title" variant="h4" component="h2">
                            Add Tenant Data
                        </Typography>
                        <br></br>
                        <Typography id="modal-modal-title" variant="h6" component="h6">
                            <FormControl fullWidth>
                                <TextField sx={{ mb: 1 }} id="tenantName" label="Tenant Name" value={tenantName} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="tenantCode" label="Tenant Code" value={tenantCode} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="email" label="Admin Email" value={email} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="sftpConfig.host" label="SFTP Host" value={sftpConfig.host} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="sftpConfig.username" label="SFTP Username" value={sftpConfig.username} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="sftpConfig.password" label="SFTP Password" value={sftpConfig.password} onChange={handleAddChange} />
                                <br></br>
                                <TextField sx={{ mb: 1 }} id="sessionExpire" type="number" label="Session Expiry Time (in hours)" value={sessionExpire} onChange={handleAddChange}  inputProps={{ min: 1 }}/>
                                <br></br>
                                Upload Tenant Logo:
                                <Input id="tenant_image_url" type="file" onChange={handleFileChange} />
                                <br></br>
                            </FormControl>
                        </Typography>

                        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                            <Button type="submit" variant="contained" color="primary" onClick={handleAddSubmit}>
                                Submit
                            </Button>
                        </Typography>
                    </Div>
                </Modal> */}
            </Box>
        </Div>
    );
};

export default SuperAdminTenantList;
